module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_ks_ssdw@2x.f0a11fb4.png";